var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "quiz-container",
    { attrs: { loading: _vm.loading } },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c("h2", { staticClass: "quiz-result-title" }, [
            _vm._v(_vm._s(_vm.sentence))
          ]),
          _vm._v(" "),
          _c(
            "swiper",
            {
              ref: "swiper",
              staticClass: "carousel",
              attrs: { options: _vm.swiperOptions },
              on: { "slide-change": _vm.handleChangeSlide }
            },
            [
              _vm._l(_vm.outfits, function(outfit) {
                return _c(
                  "swiper-slide",
                  { key: outfit.outfit_id },
                  [
                    _c("outfit-card", {
                      attrs: {
                        outfit: outfit,
                        handleProductClk: _vm.handleVisitProduct
                      }
                    })
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-pagination swiper-pagination-white",
                attrs: { slot: "pagination" },
                slot: "pagination"
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showRestartModal,
                    expression: "showRestartModal"
                  }
                ],
                staticClass: "quiz-overlay-modal"
              },
              [
                _c("div", { staticClass: "quiz-restart-modal" }, [
                  _c("h3", { staticClass: "quiz-restart-modal-title" }, [
                    _vm._v("Restart the Quiz?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "quiz-restart-modal-buttons-container" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "quiz-restart-modal-button quiz-restart-modal-button--left",
                          on: { click: _vm.restartQuiz }
                        },
                        [_vm._v("Yes")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "quiz-restart-modal-button quiz-restart-modal-button--right",
                          on: {
                            click: function($event) {
                              _vm.showRestartModal = false
                            }
                          }
                        },
                        [_vm._v("No")]
                      )
                    ]
                  )
                ])
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "cta-buttons" },
        [
          _c("share-outfit", {
            key: "share-button",
            attrs: { outfit: _vm.currentOutfit, color: "white" }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button pink main-button",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.goToGetStyled.apply(null, arguments)
                }
              }
            },
            [_vm._v("See matching Outfits")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("restart-quiz-button", {
        attrs: { slot: "exit-button-left" },
        on: {
          click: function($event) {
            $event.stopPropagation()
            _vm.showRestartModal = true
          }
        },
        slot: "exit-button-left"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8e121f4e", { render: render, staticRenderFns: staticRenderFns })
  }
}